import { toast } from "react-toastify";

import { push } from "connected-react-router";

import * as BlueprintAPI from "api/BlueprintAPI";

import * as homeReducer from "containers/Home/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as globalReducer from "containers/App/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as viewReducer from "containers/View/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as contentGenerationReducer from "containers/ContentGeneration/reducer";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";

import ThinkingStepIcon from "images/Agent Icons/Capabilities Icons/thought bubble.svg";
import AnalyticsStepIcon from "images/Templates View Icons/Type/Magic Sparkles Light (1).svg";
import NlqStepIcon from "images/Templates View Icons/Type/Simple Light Chart (1).svg";
import DocumentSummaryStepIcon from "images/Templates View Icons/Type/Font Awesome Files Light (1).svg";
import PredictionStepIcon from "images/Templates View Icons/Type/Crystal Ball Light.svg";
import ActionTreeStepIcon from "images/Templates View Icons/Type/Network Light Chart (1).svg";
import ApiStepIcon from "images/Agent Icons/Capabilities Icons/code-sharp-light.svg";
import AnythingStepIcon from "images/Agent Icons/Capabilities Icons/message-captions-light.svg";
import FileAttachIcon from "images/file-attach.svg";
import WhatsChangedStepIcon from "images/Agent Icons/StepIcons/whats-changed.svg";
import SlackStepIcon from "images/Agent Icons/StepIcons/publish.svg";
import DeepResearchStepIcon from "images/Agent Icons/StepIcons/research.svg";
import WebSearchStepIcon from "images/Agent Icons/StepIcons/web-search.svg";

import { AibleClientFactory } from "client/aible/factory";

import { getResponseContent } from "utils/chat/completion";

import * as AA_Examples from "containers/AibleAnywhere/Mock_Data/AA_Examples";
import { current } from "@reduxjs/toolkit";

import { OPTIONS as timezoneOptions } from "components/Tiles/Sense/TimezoneInput";

import { isEnabled } from "@/utils/featureFlags";
import { getStringComparator } from "@/utils/collect";
import { validateExpression } from "@/components/Tiles/Sense/CronExpressionInput";
import { getAPIToken } from "@/utils/request";
import { AccountClientWithoutFactory } from "@/client/aible/account/without_factory";
import { getUrl } from "@/client/aible/account/without_factory";
import ChatDetailsReducer from "../ChatDetails/reducer";
import { CHATAIBLE_BLUEPRINTS, CHATAIBLE_DOCUMENT_SUMMARIZATION, CHATAIBLE_SQL } from "@/containers/ChatGPT/reducer";

export const AIBLE_ANYWHERE_STEP_DESCRIPTION = {
  NLQ: {
    type: "NLQ",
    description:
      "Natural Language Queries on Datasets. Use this to execute SQL Queries on some Data. Describe the SQL query in english."
  } /*
	Analytics: {
		type: "Analytics",
		description: "Retrieve statistical information from Datasets.",
	},*/,
  Prediction: {
    type: "Prediction",
    description: "Run predictions using other AI models."
  },
  ["Just Chat"]: {
    type: "Just Chat",
    description: "Prompt an LLM with any input."
  },
  ["Document Summary"]: {
    type: "Document Summary",
    description: "Retrieve Data from a PDF or other Document."
  },
  ["Action Tree"]: {
    type: "Action Tree",
    description: "Allow user a choice of multiple options of prompting an LLM."
  }
};

export const OUTLINE_BUILDER = {
  prompt: "West Region would like to purchase 10 Live Free for their Direct Mail campaign",
  plan_description:
    "Let's help the user by calculating the price and stock quantity of the 10 Live Frees, " +
    "we can then use another model to do a Prediction and find the best region, " +
    "once we know the price and stok quantity and best region we can use this information to generate an Action Tree of possible emails",
  generate_steps: [
    /*
		{
			type: "Just Chat",
			gen_prompt: "Parse the user input for any relevant fields",
		},
		*/
    { type: "NLQ", gen_prompt: "Calculate the price", datasetId: 578 },
    {
      type: "NLQ",
      gen_prompt: "Calculate the stock quantity",
      datasetId: 578
    },
    {
      type: "Prediction",
      gen_prompt: "Find the best Region",
      projectId: 1425
    },
    {
      type: "Action Tree",
      gen_prompt: "Generate 4 different common email requests"
    }
  ]
};

export const EXAMPLE_INTENT = {
  parsedFields: [
    { field: "Region", value: "West", datasetId: 578 },
    {
      field: "Product",
      value: "Live Free",
      quantity: 10,
      datasetId: 578
    },
    { field: "Campaign", value: "Direct Mail", datasetId: 578 }
  ]
};

const exampleJsonResponse = {
  field: "Field 1",
  value: "Value 1",
  quantity: "10"
};

export const TEST_STEPS = {
  name: "Pricing Demo",
  isAibleAgent: true,
  defaultPrompt: "West Region would like to purchase 10 Live Free for their Direct Mail campaign",
  steps: [
    {
      Title: "Intent JSON",
      Type: "Just Chat",
      Prompt:
        `Take the following User Prompt and give me back a raw JSON object with keys
'field', 'value', and 'quantity'. The field should be Product, try to parse the rest from the User Prompt.
Example JSON Response: ` +
        JSON.stringify(exampleJsonResponse) +
        `
The response must be only JSON, no additional markdown or text.
User Prompt: {{prompt}}`
    },
    {
      Title: "Calculate Price",
      DatasetId: 8878,
      Type: "NLQ",
      Prompt:
        "Calculate a total order value by searching for the unit price that matches " +
        "{{step_1.field}} {{step_1.value}} and multiplying by" +
        " the order quantity: {{step_1.quantity}}"
    },
    {
      Title: "Calculate Quantity",
      DatasetId: 8878,
      Type: "NLQ",
      Prompt:
        "Get the quantity in stock for {{step_1.field}} {{step_1.value}}. Show the number in stock and " +
        "indicate whether there are sufficient" +
        " to cover an order of {{step_1.quantity}} items."
    },
    {
      Title: "Credit Risk",
      Type: "Analytics",
      DatasetId: 8879,
      Prompt:
        "I'm going to be buying {{step_3.output}} of this {{step_1.field}} {{step_1.value}} in the " +
        "Direct Mail Campaign " +
        "for ${{step_2.output}}, do you know anything interesting about this?"
    },
    {
      Title: "Predict",
      Type: "Prediction",
      ProjectId: 4905,
      Prompt: "Let's find out which Contact_Month is the most likely to succeed in our Outcome."
    },
    {
      Title: "How would you like to proceed?",
      Type: "Action Tree",
      Prompt:
        "Draft an email for the person running the Direct Mail Campaign, " +
        "thanking them for their enquiry for {{step_1.quantity}} {{step_1.value}} for their " +
        "Direct Mail Campaign",
      Actions: [
        {
          Text: "Prepare a quote for the items",
          Prompt_Append:
            "\nInclude a quote of ${{step_2.output}} and tell them the " +
            "shipper will be {{step_4.output}}. Payment terms are 60 days."
        },
        {
          Text: "Decline to quote due to credit risk",
          Prompt_Append: "\nPolitely decline to quote for the items on the grounds that they are a credit risk."
        },
        {
          Text: "Warn of low stock",
          Prompt_Append:
            "\nAdvise them that the items are likely to be delivered a little late and ask if they would like to proceed anyway."
        },
        {
          Text: "Warn of possible late delivery",
          Prompt_Append:
            "\nAdvise them that the items are out of stock and ask if they would like to proceed with a delayed delivery."
        }
      ]
    }
  ]
};

const CREATE_NEW = {
  steps: [
    {
      Title: "Intent JSON",
      Type: "NLQ",
      Prompt:
        "Take the following User Prompt as well as a list of Fields from a Dataset, and give me back a raw JSON object with keys 'intent', and other other's that match from the Dataset fields. You should also have a ‘quantity’ field if the user has a quantity in the prompt. The response must be only JSON, no additional markdown or text."
    }
  ]
};

export const CLAW_COLLECTION_ID_LOCATIONS = ["cronJobs", "apiInvocations"];
// id 14 is the memory tool and needs to be hidden from selectable tools
export const CLAW_HIDDEN_TOOLS = [14];

const UPDATE_BASE = "aibleAnywhere/UPDATE_BASE";
const UPDATE_FIELD = "aibleAnywhere/UPDATE_FIELD";
const DELETE_FIELD = "aibleAnywhere/DELETE_FIELD";
const UPDATE_FIELD_VALUE = "aibleAnywhere/UPDATE_FIELD_VALUE";

const initialState = {
  ["Pricing Demo"]: TEST_STEPS,
  ["LinkedIn Hires"]: AA_Examples.FULL_BUILDER_GAMING,
  ["Analytics"]: {
    name: "Analytics",
    description:
      "Generate a summary of analytics, highlighting key insights and performance " +
      "trends for your KPIs. This will use the Aible information model to find top insights.",
    isAibleAgent: true,
    steps: [
      {
        Title: "Analytics",
        DatasetId: undefined,
        Type: "Analytics",
        Prompt: "Enter prompt for Analytics question against a Dataset."
      }
    ]
  },
  ["Data Query (NLQ)"]: {
    name: "Data Query (NLQ)",
    description: "Use natural language to search and retrieve data insights quickly and intuitively.",
    isAibleAgent: true,
    steps: [
      {
        Title: "NLQ",
        DatasetId: undefined,
        Type: "NLQ",
        Prompt: "Enter prompt for NLQ question against a Dataset."
      }
    ]
  },
  ["Document Summarization"]: {
    name: "Document Summarization",
    description: "Summarize unstructured data from PDFs and documents to extract key points and insights.",
    isAibleAgent: true,
    steps: [
      {
        Title: "Document Summarization",
        ArtifactId: undefined,
        Type: "Document Summarization",
        Prompt: "Enter prompt for Document Summarization question against a Document Set."
      }
    ]
  }
};

function aibleAnywhereReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BASE:
      return {
        ...action.data
      };
    case UPDATE_FIELD:
      return {
        ...state,
        [action.id]: action.data
      };
    case DELETE_FIELD: {
      const retState = { ...state };
      if (action?.id && retState[action.id]) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete retState[action.id];
      }
      return retState;
    }
    case UPDATE_FIELD_VALUE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.key]: action.data
        }
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.aibleAnywhere;
}

export function getAibleAnywhere(state, id) {
  return getBase(state) ? getBase(state)[id] : undefined;
}

export function getName(state, id) {
  return getBase(state)?.[id]?.name ?? "New Aible Agent";
}

export function getGenerateAgentC(state) {
  return getBase(state)?.["misc"]?.generateAgentC;
}

export function getTestCronIndex(state) {
  return getBase(state)?.["misc"]?.testCronIndex;
}

export function getPredictNextId(state) {
  return getBase(state)?.["misc"]?.predictNextId;
}

export function getIsLoading(state, id) {
  const aaProject = getAibleAnywhere(state, id);

  return aaProject?.isLoading;
}

export function getIsRegenLoading(state, id) {
  const aaProject = getAibleAnywhere(state, id);

  return aaProject?.isRegenLoading;
}

export function getSuggestPrompts(state, id) {
  const aaProject = getAibleAnywhere(state, id);

  return aaProject?.suggestPrompts;
}

export function getCurrentProject(state, id) {
  const aaProject = chatGPTReducer.getSelectedAAProject(state, id);

  return getAibleAnywhere(state, aaProject);
}

export function getBlueprintIdForTool(state, id, toolName) {
  const agent = getAibleAnywhere(state, id);

  return (agent?.tool_list ?? []).find((t) => t?.name === toolName)?.blueprintId;
}

export function getClawTaskOptions(state, id) {
  const retOptions = [];
  const currClaw = getAibleAnywhere(state, id);
  for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
    for (let i = 0; i < currClaw?.[key]?.length; i++) {
      const currJob = currClaw[key][i];
      const cTaskName = getTaskName(key, i);

      const retLabel = currJob?.name ?? cTaskName;

      retOptions.push({
        label: retLabel,
        value: {
          ...currJob,
          name: retLabel,
          index: i,
          type: key
        }
      });
    }
  }

  return retOptions;
}

// These names may need help, but they're what we use in the setup
export function getTaskName(key, index) {
  let identifier = index !== undefined ? " " + (index + 1) : "";
  const taskNameLookup = {
    cronJobs: "Schedule",
    apiInvocations: "API Invocation"
  };
  const cTaskName = (taskNameLookup[key] ?? key) + identifier;

  return cTaskName;
}

export function getClawActivity(state, id) {
  const retData = [];
  const currClaw = getAibleAnywhere(state, id);
  for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
    for (let i = 0; i < currClaw?.[key]?.length; i++) {
      const currJob = currClaw[key][i];
      if (currJob.executions) {
        const cTaskName = getTaskName(key, i);
        // iterate across the executions and construct the expected messages
        // the keys we're looking for are placeholder keys and should be easily replaced/changed
        currJob.executions?.forEach((cExec) => {
          const results = cExec.results ?? [];
          const lastResult = results[results.length - 1];

          if (lastResult === undefined || lastResult.data === undefined) {
            return;
          }

          const query = lastResult.data.input.messages.find((m) => m.role == "user")?.content;

          const response = lastResult.data.output.content;

          let retEntry = {
            collectionId: currJob.collection_id ?? cExec.collection_id,
            name: cTaskName,
            created_date: cExec.created_date, // Time the current execution was made, should have date and maybe time?
            updated_date: cExec.updated_date ?? cExec.created_date,
            query: query, // the prompt that was sent
            response: response // the result of that query,
          };

          const datasetId = cExec?.results?.[0]?.validation_result?.references?.[0]?.reference?.dataset_id;

          if (
            Object.keys(cExec?.results?.[0]?.validation_result?.references ?? []).length > 0 &&
            datasetId !== undefined
          ) {
            retEntry.contentGenerationIds = [cExec?.id];
            retEntry.contentGenerationAccount = chatGPTReducer.getChatGPTAccountId(state);
            retEntry.datasetId = datasetId;
            retEntry.response_data = cExec?.results?.[0]?.data;
            retEntry.content_references = cExec?.results?.[0]?.validation_result?.references;
          }

          // add to retData after we add values for component
          retData.push(retEntry);
        });
      }
    }
  }

  return retData.sort(getStringComparator((x) => x.created_date));
}

export function getClawAgentFromChat(state) {
  const nextId = nextReducer.getCurrentNextId(state);

  const datasetId = nextReducer.getDatasetId(state, nextId);
  const reportLabel = nextReducer.getReportLabel(state, nextId);

  const accountId = accountsReducer.getSelectedAccountId(state);

  // use the currently selected chatTone as the default
  const chatTone = chatGPTReducer.getChatTone(state);

  // This doesn't get the chatapp, just the usecase the chatapp uses
  const chatBlueprintId = chatGPTReducer.getBlueprintId(state);

  // Initial empty agent
  const retAgent = {
    isAgentC: true,
    isEnabled: true,
    accountId: accountId,
    chatBlueprintId: chatBlueprintId,
    chatOverrides: {
      chatTone: chatTone
    },
    name: reportLabel,
    cronJobs: []
  };

  const modelId = chatGPTReducer.getModelId(state);

  // Generate cronJob framework
  const cronJob = {
    prompt: "",
    cron_expr: "0 0 * * *",
    timezone: "UTC",
    chatOverrides: {
      modelId: modelId
    },
    blueprintOptions: []
  };
  // use last user question as prompt
  const questionIndex = chatGPTReducer.getQuestionIndex(state);
  let questionMessage = chatGPTReducer.getConversationMessage(state, questionIndex);
  // if the questionMessage we find isn't actually a question because the question index returns 0 if there are no questions
  if (!questionMessage?.isQuestion) {
    questionMessage = undefined;
  }
  let prompt = questionMessage?.userPrompt ?? questionMessage?.userText ?? questionMessage?.text;
  if (!prompt || prompt === "Summarizing with ChatAible") {
    prompt = `Provide a general summary of the data. I am interested in key predictive features or feature interactions that may indicate trends. Use specific numbers and values from the data to support your conclusions.`;
  }
  cronJob.prompt = prompt;

  // get the current blueprint for the project
  const blueprintId = chatGPTReducer.getBlueprintId(state);
  const blueprint = blueprintReducer.getBlueprint(state, blueprintId);
  if (blueprint) {
    const blueprintName = blueprint?.name;
    const blueprintDescription = blueprint?.wizard?.description;

    // get the chatType which we use to figure out the tool id
    const chatType = chatGPTReducer.getChatType(state);
    const toolList = chatGPTReducer.getAgentIQToolOptions();

    const chatTool = toolList.find((tool) => {
      if (!tool?.blueprint_id) {
        return false;
      }
      // match the chatType in the blueprints
      const toolBlueprint = blueprintReducer.getBlueprint(tool.blueprint_id);
      if (toolBlueprint?.wizard?.chatGPT?.chatType === chatType) {
        return true;
      }
      // fallback chatType matching with tool value
      const chatTypeLookup = {
        summarize_document: ["DOCUMENT"],
        dataset_nlq: ["SQL"],
        analyze_dataset: ["AIBLE", "ANALYTICS"]
      };
      if (chatTypeLookup[tool?.value]?.includes(chatType)) {
        return true;
      }
      return false;
    });
    const toolId = chatTool?.id;

    const tool = {
      label: blueprintName,
      value: blueprintId,
      blueprint_id: blueprintId,
      description: blueprintDescription,
      input_payload: {
        dataset_id: datasetId
      },
      type: "blueprint",
      id: toolId
    };
    cronJob.blueprintOptions.push(tool);
  }

  retAgent.cronJobs.push(cronJob);

  return retAgent;
}

export function getClawAPIActivationExample(url, keyword, language) {
  let retLanguage = language ?? "CURL";

  const bearer_token = getAPIToken();

  let request;
  if (retLanguage === "JAVASCRIPT") {
    request = `// Any JSON you want to send to the Agent
const payload = {
  "sku": "product",
  "quantity": 0
}
const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ${bearer_token}'
  },
  body: payload
};

fetch('${url}/v1/webhooks/${keyword}', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.error(err));`;
  } else if (retLanguage === "PYTHON") {
    request = `import requests

url = "${url}/v1/webhooks/${keyword}"

# Any JSON you want to send to the Agent
payload = {
    "sku": "product",
    "quantity": 0
}
headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer ${bearer_token}"
}

response = requests.request("POST", url, json=payload, headers=headers)

print(response.text)`;
  } else {
    request = `curl --request POST \\
  --url ${url}/v1/webhooks/${keyword} \\
  --header 'Authorization: Bearer ${bearer_token}' \\
  --header 'Content-Type: application/json' \\
  --data '{"sku": "product", "quantity": 0}' # Any JSON you want to send to the Agent`;
  }

  return request;
}

export function getClawTaskStepAgentIdsFromId(state, id) {
  const anywhereAgent = getAibleAnywhere(state, id);
  const cronJobs = anywhereAgent?.cronJobs ?? [];
  const apiInvocations = anywhereAgent?.apiInvocations ?? [];

  const agentIds = [];
  for (const job of cronJobs) {
    const jobBlueprintOptions = job?.blueprintOptions ?? [];
    for (const bpOption of jobBlueprintOptions) {
      const isStepAgentTool = bpOption?.blueprint_id !== undefined && bpOption?.id === 9;
      if (isStepAgentTool && !agentIds.includes(bpOption.blueprint_id)) {
        agentIds.push(bpOption.blueprint_id);
      }
    }
  }

  for (const invocation of apiInvocations) {
    const invocationBlueprintOptions = invocation?.blueprintOptions ?? [];
    for (const bpOption of invocationBlueprintOptions) {
      const isStepAgentTool = bpOption?.blueprint_id !== undefined && bpOption?.id === 9;
      if (isStepAgentTool && !agentIds.includes(bpOption.blueprint_id)) {
        agentIds.push(bpOption.blueprint_id);
      }
    }
  }

  return agentIds;
}

export function getClawTaskUsedStepWorkflowsFromId(state, id, agentOverride) {
  const anywhereAgent = agentOverride ?? getAibleAnywhere(state, id);
  const cronJobs = anywhereAgent?.cronJobs ?? [];
  const apiInvocations = anywhereAgent?.apiInvocations ?? [];
  const executionWorkflows = anywhereAgent?.executionWorkflows ?? {};

  const usedWorkflowPlanIds = [];
  for (const job of cronJobs) {
    const jobBlueprintOptions = job?.blueprintOptions ?? [];
    for (const bpOption of jobBlueprintOptions) {
      const isStepWorkflow = bpOption?.workflow_plan !== undefined && bpOption?.id === 9;
      if (
        isStepWorkflow &&
        !usedWorkflowPlanIds.includes(bpOption.blueprint_id) &&
        executionWorkflows?.[bpOption?.workflow_plan] !== undefined
      ) {
        usedWorkflowPlanIds.push(bpOption.workflow_plan);
      }
    }
  }

  for (const invocation of apiInvocations) {
    const invocationBlueprintOptions = invocation?.blueprintOptions ?? [];
    for (const bpOption of invocationBlueprintOptions) {
      const isStepWorkflow = bpOption?.workflow_plan !== undefined && bpOption?.id === 9;
      if (
        isStepWorkflow &&
        !usedWorkflowPlanIds.includes(bpOption.blueprint_id) &&
        executionWorkflows?.[bpOption?.workflow_plan] !== undefined
      ) {
        usedWorkflowPlanIds.push(bpOption.workflow_plan);
      }
    }
  }

  return usedWorkflowPlanIds;
}

/* Actions */
export function updateBase(aibleAnywhereProjects) {
  return (dispatch, getState) => {
    return dispatch({ type: UPDATE_BASE, data: aibleAnywhereProjects });
  };
}

export function deleteIdFromState(id) {
  return (dispatch, getState) => {
    return dispatch({ type: DELETE_FIELD, id });
  };
}

export function updateIsLoading(id, isLoading) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: isLoading,
      key: "isLoading"
    });
  };
}

export function updateIsRegenLoading(id, isRegenLoading) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: isRegenLoading,
      key: "isRegenLoading"
    });
  };
}

export function updateSuggestPrompts(id, suggestPrompts) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: suggestPrompts,
      key: "suggestPrompts"
    });
  };
}

export function updateBlueprintIdForTool(id, toolName, blueprintId) {
  return (dispatch, getState) => {
    let agent = { ...(getAibleAnywhere(getState(), id) ?? {}) };

    const agentIQToolOptions = chatGPTReducer.getAgentIQToolOptions();

    /*
    for (let i = 0; i < (agent?.tool_list ?? []).length; i++) {
      if (agent?.tool_list?.[i]?.name !== undefined && agent?.tool_list?.[i]?.name === toolName) {
        agent.tool_list[i].blueprintId = blueprintId;
      }
    }
    */

    const foundToolId = agentIQToolOptions.find((t) => t?.value === toolName);
    let foundTool =
      foundToolId === undefined
        ? (agent?.tool_list ?? []).find((t) => t.name === toolName)
        : (agent?.tool_list ?? []).find((t) => Number(t.id) === Number(foundToolId?.id));

    //let foundTool = (agent?.tool_list ?? []).find((t) => t?.name === toolName);

    if (foundTool !== undefined) {
      foundTool.blueprint_id = blueprintId;
    }

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: agent.tool_list,
      key: "tool_list"
    });
  };
}

export function testCronWithDataset(cronJob) {
  return async (dispatch, getState) => {
    dispatch(chatGPTReducer.updateIsAsking(true));

    // make sure there's valid blueprintOptions
    // if not, create our own from the current settings

    // this is the first valid tool we can find, use it to display the datasetid
    // we are making a soft assumption here that there is only a single tool like this
    // for the purposes of displaying the message
    let targetTool = cronJob?.blueprintOptions?.find((t) => t?.blueprint_id && t?.input_payload?.dataset_id);

    let tools = cronJob?.blueprintOptions;
    if (!tools?.length || !targetTool) {
      const blueprintId = chatGPTReducer.getBlueprintId(getState());
      const nextId = nextReducer.getCurrentNextId(getState());
      const datasetId = nextReducer.getDatasetId(getState(), nextId);
      const modelId = chatGPTReducer.getModelId(getState());
      targetTool = {
        type: "blueprint",
        blueprint_id: blueprintId,
        input_payload: {
          dataset_id: datasetId
        }
      };
      tools = [targetTool];
    }

    const questionIndex = dispatch(
      chatGPTReducer.addMessageConversation(
        {
          user: "User",
          text: cronJob?.prompt,
          date: new Date(),
          isQuestion: true,
          alwaysShowStep: true
        },
        undefined,
        true
      )
    );

    const tone = chatGPTReducer.getChatToneText(getState());

    // For some reason sending the tone in the system prompt gets ignored by oss
    const retPrompt = tone + "\n\nUser Question:\n" + cronJob?.prompt;

    const stepResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: retPrompt }],
        tools: tools
      })
    );

    let parsedResponseText = chatGPTReducer.decryptResponse(getState(), getResponseContent(stepResponse));

    dispatch(
      chatGPTReducer.addMessageConversation({
        user: "Aible",
        userText: parsedResponseText,
        date: new Date(),
        questionIndex: questionIndex,

        ids: [stepResponse?.id],
        response_data: stepResponse.data,
        responseDate: stepResponse.updated_date,
        alwaysShowStep: false,
        datasetId: targetTool?.input_payload?.dataset_id,
        contentGenerationIds: [stepResponse?.id],
        contentGenerationAccount: chatGPTReducer.getChatGPTAccountId(getState())
      })
    );

    await dispatch(chatGPTReducer.askGPTAnnotate(stepResponse, true, questionIndex, undefined, false));

    dispatch(chatGPTReducer.updateIsAsking(false));

    console.log("what is stepResponse", stepResponse);
  };
}

export function saveAibleAnywhere(
  aaProject,
  name = "AA Project Test",
  openAgentOnSave = false,
  updateAgentOnSave = false,
  saveAsNew = false,
  saveToMyWork = true,
  skipExecutionMetadataPatch = false,
  checkExecutionAndUpdateWorkflow = false
) {
  return async (dispatch, getState) => {
    // Need to remove api_inclusions if the flag is turned off for aible claw
    // Might need to change this and continue saving it but not consume it without the flag instead.
    const retAaProject = { ...aaProject };

    if (retAaProject?.isAgentC && retAaProject?.apiInvocations && !isEnabled("aible-claw-api-invocations")) {
      delete retAaProject.apiInvocations;
    }

    // Save tone_id if agent isAgentC so that tones are saved, will be loaded with useEffect
    if (retAaProject?.isAgentC) {
      retAaProject.tone_id = chatGPTReducer.getChatTone(getState());
    }

    let bpAAProject = {
      wizard: { aibleAnywhere: { ...retAaProject, name: name } },
      name: name
    };

    delete bpAAProject?.wizard?.aibleAnywhere?.original_tool_list;

    console.log("save aa", bpAAProject);

    let saveResponse = undefined;

    if (isNaN(aaProject?.id) || saveAsNew === true) {
      console.log("create new blueprint");
      saveResponse = await dispatch(
        blueprintReducer.createBlueprintFromBlueprint(
          bpAAProject,
          undefined,
          openAgentOnSave,
          saveToMyWork,
          false,
          "Agent successfully created"
        )
      );
    } else {
      console.log("update blueprint ", aaProject?.id);

      const retProject = { ...(retAaProject ?? {}) };
      delete retProject?.original_tool_list;

      saveResponse = await BlueprintAPI.updateBlueprintRawRequest(
        retProject?.id,
        { aibleAnywhere: { ...retProject, name: name } },
        retProject?.name
      );
    }

    // Hacky way to update a Read Memory blueprint_id on save with the agent's blueprint_id
    if (saveResponse && retAaProject?.isAgentC && retAaProject?.cronJobs?.length) {
      const hasMissingMemoryBlueprintId = retAaProject.cronJobs.some((job) => {
        return job?.blueprintOptions?.some((tool) => tool?.id === "14" && tool?.blueprint_id === undefined);
      });

      if (hasMissingMemoryBlueprintId) {
        let retProject = { ...saveResponse.wizard.aibleAnywhere };
        const updatedJobs = retProject.cronJobs.map((job) => {
          const updatedBpOptions = job?.blueprintOptions.map((tool) => {
            if (tool?.id === "14" && tool?.blueprint_id === undefined) {
              return {
                ...tool,
                blueprint_id: saveResponse?.id
              };
            }
            return tool;
          });

          return {
            ...job,
            blueprintOptions: updatedBpOptions
          };
        });

        retProject = {
          ...retProject,
          cronJobs: updatedJobs
        };

        saveResponse = await BlueprintAPI.updateBlueprintRawRequest(
          saveResponse?.id,
          { aibleAnywhere: { ...retProject, name: name } },
          saveResponse?.name
        );
      }
    }

    if (aaProject?.executionId !== undefined) {
      const account = accountsReducer.getSelectedAccount(getState());
      const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(account.id);
      const agentClient = acf.getAgentExecutionClient();

      if (!skipExecutionMetadataPatch) {
        const currentExecutionMetadata = await agentClient.getExecutionMetadata(aaProject?.executionId);

        const shouldUpdateExecutionMetadata =
          currentExecutionMetadata?.data?.name !== name ||
          currentExecutionMetadata?.data?.description !== aaProject?.description ||
          JSON.stringify(currentExecutionMetadata?.data?.steps) !== JSON.stringify(aaProject?.execution_steps) ||
          JSON.stringify(currentExecutionMetadata?.data?.tool_list) !== JSON.stringify(aaProject?.tool_list);

        if (shouldUpdateExecutionMetadata) {
          await agentClient.updateExecutionMetadata(aaProject?.executionId, {
            name: name,
            description: aaProject?.description,
            steps: aaProject?.execution_steps,
            tool_list: aaProject?.tool_list
          });
        }
      }

      if (checkExecutionAndUpdateWorkflow) {
        const currentExecutionWorkflow = await agentClient.getOrCreateExecutionWorkflowPlan(aaProject?.executionId);
        const shouldUpdateExecutionWorkflow =
          JSON.stringify(currentExecutionWorkflow?.data?.steps) !== JSON.stringify(aaProject?.execution_steps);

        if (shouldUpdateExecutionWorkflow && aaProject?.execution_steps) {
          await agentClient.updateExecutionWorkflowPlan(aaProject?.executionId, {
            steps: aaProject?.execution_steps
          });
        }
      }
    }

    if (updateAgentOnSave === true) {
      dispatch(chatGPTReducer.updateAgentId(saveResponse?.id));

      const nextId = nextReducer.getCurrentNextId(getState());
      dispatch(nextReducer.saveNext(nextId, undefined, false));
    }

    return saveResponse;
  };
}

export function checkUpdateExecutionMetadata(executionId, name, description, execution_steps, tool_list) {
  return async (dispatch, getState) => {
    const account = accountsReducer.getSelectedAccount(getState());
    const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(account.id);
    const agentClient = acf.getAgentExecutionClient();

    console.log("what is account", account);

    const currentExecutionMetadata = await agentClient.getExecutionMetadata(executionId);

    const shouldUpdate =
      currentExecutionMetadata?.data?.name !== name ||
      currentExecutionMetadata?.data?.description !== description ||
      JSON.stringify(currentExecutionMetadata?.data?.steps) !== JSON.stringify(execution_steps) ||
      JSON.stringify(currentExecutionMetadata?.data?.tool_list) !== JSON.stringify(tool_list);

    if (shouldUpdate) {
      agentClient.updateExecutionMetadata(executionId, {
        name: name,
        description: description,
        steps: execution_steps,
        tool_list: tool_list
      });
    }
  };
}

export function updateAibleAnywhere(id, data) {
  return (dispatch, getState) => {
    const oBase = getBase(getState());

    return dispatch(updateBase({ ...oBase, [id]: data }));
  };
}

export function resetNewAibleAnywhere() {
  return (dispatch, getState) => {
    return dispatch(updateAibleAnywhere("new", {}));
  };
}

export function fetchExecutionMetadata(agentId) {
  return async (dispatch, getState) => {
    const accountId = accountsReducer.getSelectedAccountId(getState());
    const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(accountId);
    const agentClient = acf.getAgentExecutionClient();

    const agent = getAibleAnywhere(getState(), agentId);

    const executionMetadataResponse = await agentClient.getExecutionMetadata(agent?.executionId);

    console.log("what is executionMetadataResponse", executionMetadataResponse, agent, agentId);

    const retAgent = {
      ...agent,
      description: executionMetadataResponse?.data?.description,
      name: executionMetadataResponse?.data?.name
    };

    dispatch(updateAibleAnywhere(agentId, retAgent));

    return executionMetadataResponse;
  };
}

export function updateGenerateAgentC(generateAgentC) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: "misc",
      data: generateAgentC,
      key: "generateAgentC"
    });
  };
}

export function updatePredictNextId(predictNextId) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: "misc",
      data: predictNextId,
      key: "predictNextId"
    });
  };
}

export function updateTestCronIndex(testCronIndex) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: "misc",
      data: testCronIndex,
      key: "testCronIndex"
    });
  };
}

export function updateName(id, name) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: name,
      key: "name"
    });
  };
}

export function updateDescription(id, description) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: description,
      key: "description"
    });
  };
}

export function updateRunToggle(id, runToggle) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: runToggle,
      key: "runToggle"
    });
  };
}

// checks if the agent is ready for saving
export function isValidClawAgent(agent) {
  // Agent is valid if it has at least one cron job with a prompt, selected tools, and a cron expression
  if (agent?.cronJobs?.length && agent?.cronJobs?.find((j) => j.prompt && j.blueprintOptions?.length && j.cron_expr)) {
    return true;
  }
  // Valid if it has at least one api with a prompt, selected tools, and api selections
  if (
    agent?.apiInvocations?.length &&
    agent?.apiInvocations?.find((j) => j.prompt && j.blueprintOptions?.length && j.intervalOptions?.length)
  ) {
    return true;
  }

  return false;
}

// Fetch all the relevant data to the currently selected claw agent
// this does not set the agent as the current aa agent or clear the chatgpt reducer
export function initClaw(agentId) {
  return async (dispatch, getState) => {
    const agentBp = blueprintReducer.getBlueprint(getState(), agentId);
    if (!agentBp && !isNaN(Number(agentId))) {
      await dispatch(blueprintReducer.fetchBlueprint(agentId));
    }
    const aaAgent = getAibleAnywhere(getState(), agentId);
    if (!aaAgent && !isNaN(Number(agentId))) {
      dispatch(fetchAAProject(agentId));
    }
    const retAgent = getAibleAnywhere(getState(), agentId);
    // Fetch the associated usecase if it's not already fetched
    // initialize the prompt values from that usecase
    const chatBlueprintId = retAgent?.chatBlueprintId;
    if (chatBlueprintId) {
      const chatBp = blueprintReducer.getBlueprint(getState(), chatBlueprintId);
      if (!chatBp && !isNaN(Number(chatBlueprintId))) {
        await dispatch(blueprintReducer.fetchBlueprint(chatBlueprintId));
      }
      dispatch(chatGPTReducer.selectBlueprint(chatBlueprintId));
    }
    await dispatch(fetchClawActivity(agentId));
    return Promise.resolve();
  };
}

export function saveClawAgent(agent, name, useChatCollectionId, saveToMyWork, saveAsNew, chatblueprintIdOverride) {
  return async (dispatch, getState) => {
    const accountId = accountsReducer.getSelectedAccountId(getState());
    const chatTone = chatGPTReducer.getChatTone(getState());

    const chatBlueprintId = chatGPTReducer.getBlueprintId(getState());

    // Inject collectionId to crons and apis
    const deletedExecutions = {};
    const retAgent = {
      ...agent,
      predictNextId: undefined, // This is the configure key for optimize projects, remove this to make the chat not save the right panel being open
      accountId: accountId,
      chatBlueprintId: chatblueprintIdOverride ?? chatBlueprintId,
      chatOverrides: {
        ...agent.chatOverrides,
        chatTone: chatTone
      },
      cronJobs: agent?.cronJobs ? [...agent.cronJobs] : undefined,
      apiInvocations: agent?.apiInvocations ? [...agent.apiInvocations] : undefined
    };
    for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
      if (!retAgent[key]?.length) {
        delete retAgent[key];
      } else {
        if (retAgent?.[key]?.length) {
          deletedExecutions[key] = new Array(retAgent[key].length);
        }
        for (let i = 0; i < retAgent?.[key]?.length; i++) {
          const currJob = {
            ...retAgent[key][i]
          };
          // Also create default collection when saving as new.
          if (!currJob.collection_id || saveAsNew) {
            currJob.collection_id = await dispatch(
              chatGPTReducer.createDefaultCollection(undefined, currJob?.prompt ?? "Aible Claw", !useChatCollectionId)
            );
          }
          // don't save the executions we injected into the aa agent, restore the executions after the save
          deletedExecutions[key][i] = currJob.executions;
          delete currJob.executions;
          retAgent[key][i] = currJob;
        }
      }
    }
    const newBP = await dispatch(saveAibleAnywhere(retAgent, name, undefined, undefined, saveAsNew, saveToMyWork));
    if (newBP?.id) {
      dispatch(blueprintReducer.updateBlueprint(newBP.id, newBP));
      dispatch(fetchAAProject(newBP.id));
    }

    const newAgent = getAibleAnywhere(getState(), newBP?.id);
    let retNewAgent;
    // inject the deleted executions back into the agent
    for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
      for (let i = 0; i < newAgent?.[key]?.length; i++) {
        if (deletedExecutions[key][i]) {
          if (!retNewAgent) {
            retNewAgent = { ...newAgent };
            retNewAgent[key][i].executions = deletedExecutions[key][i];
          }
        }
      }
    }
    if (retNewAgent) {
      dispatch(updateAibleAnywhere(newBP?.id, retNewAgent));
    }
    return retNewAgent ?? newAgent;
  };
}

export function saveAiqAgent(agent, name) {
  return async (dispatch, getState) => {
    const accountId = accountsReducer.getSelectedAccountId(getState());

    const chatBlueprintId = chatGPTReducer.getBlueprintId(getState());

    const retAgent = {
      ...agent,
      accountId: accountId,
      chatBlueprintId: chatBlueprintId
    };

    const newBP = await dispatch(saveAibleAnywhere(retAgent, name));
    if (newBP?.id) {
      dispatch(blueprintReducer.updateBlueprint(newBP.id, newBP));
      dispatch(fetchAAProject(newBP.id));
    }

    const newAgent = getAibleAnywhere(getState(), newBP?.id);

    return newAgent;
  };
}

export function createAiqDeepResearch(prompt) {
  return async (dispatch, getState) => {
    try {
      const completionPayload = {
        messages: [{ role: "user", content: prompt }],
        generation_config: {
          ...chatGPTReducer.getGenerationConfig(getState()),
          temperature: 0.2,
          max_tokens: 8000,
          presence_penalty: 0,
          aiq_deep_research_config: {
            agent_type: "deep_researcher"
          }
        }
      };

      const completionResponse = await dispatch(
        chatGPTReducer.doCompletionDefaultWithoutPolling(completionPayload, true)
      );

      return completionResponse?.id;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
}

export function startAiqDeepResearch(prompt, name = "New Deep Research Agent") {
  return async (dispatch, getState) => {
    const jobId = await dispatch(createAiqDeepResearch(prompt));
    const accountId = accountsReducer.getSelectedAccountId(getState());

    const newAgent = {
      name: name,
      accountId: accountId,
      aiqType: "DEEP_RESEARCH",
      aiqPrompt: prompt,
      aiqExecutionId: jobId
    };

    return await dispatch(saveAiqAgent(newAgent, name));
  };
}

// Fetch all the relevant data to the currently selected aiq agent
// this does not set the agent as the current aa agent or clear the chatgpt reducer
export function initAiq(agentId) {
  return async (dispatch, getState) => {
    const agentBp = blueprintReducer.getBlueprint(getState(), agentId);
    if (!agentBp && !isNaN(Number(agentId))) {
      await dispatch(blueprintReducer.fetchBlueprint(agentId));
    }
    const aaAgent = getAibleAnywhere(getState(), agentId);
    if (!aaAgent && !isNaN(Number(agentId))) {
      dispatch(fetchAAProject(agentId));
    }
    const retAgent = getAibleAnywhere(getState(), agentId);
    // Fetch the associated usecase if it's not already fetched
    // initialize the prompt values from that usecase
    const chatBlueprintId = retAgent?.chatBlueprintId;
    if (chatBlueprintId) {
      const chatBp = blueprintReducer.getBlueprint(getState(), chatBlueprintId);
      if (!chatBp && !isNaN(Number(chatBlueprintId))) {
        await dispatch(blueprintReducer.fetchBlueprint(chatBlueprintId));
      }
      dispatch(chatGPTReducer.selectBlueprint(chatBlueprintId));
    }
    // await dispatch(fetchClawActivity(agentId));
    console.log("<----FETCHING DETAIL FOR: ", retAgent, retAgent?.aiqExecutionId);
    dispatch(chatDetailsReducer.fetchChatMessageDetails(retAgent?.aiqExecutionId));
    return Promise.resolve();
  };
}

// Preps the chatgptreducer for any claw test chats
// this includes clearing the message history and adding the activity messages
export function initClawTest(agentId, cronJob, cronIndex) {
  return async (dispatch, getState) => {
    dispatch(chatGPTReducer.init());

    dispatch(chatGPTReducer.updateAgentId(agentId ?? "TEST_SCHEDULE"));

    await dispatch(chatGPTReducer.cancelAgent(true));

    // Use the correct collection id or set it to undefined if there isn't one yet
    dispatch(chatGPTReducer.updateCollectionId(cronJob?.collection_id));

    dispatch(chatGPTReducer.updateAgentIQMessageHistory(undefined));

    if (cronJob?.executionMetadata?.execution_id !== undefined) {
      await dispatch(
        checkUpdateExecutionMetadata(
          cronJob?.executionMetadata?.execution_id,
          cronJob?.executionMetadata?.data?.name,
          cronJob?.executionMetadata?.data?.description,
          cronJob?.executionMetadata?.data?.steps,
          cronJob?.executionMetadata?.data?.tool_list
        )
      );
    }
    // add messages to the conversation because init clears the conversation
    dispatch(addMessagesFromAgentCollection(agentId, cronJob?.collection_id));

    return Promise.resolve();
  };
}

export function shouldInjectSlackTool(task) {
  const hasSlackChannel = task?.slackChannel !== undefined;
  const usesSlack = Boolean(task?.communicationOptions?.find((o) => o?.value === "Slack"));

  return hasSlackChannel && usesSlack;
}

export function testApiInvocation(agentId, apiInvocation, indexOverride, useCache = false) {
  return async (dispatch, getState) => {
    const appIndex = indexOverride ?? apiInvocation?.index;

    let retBlueprintOptions = [...(apiInvocation?.blueprintOptions ?? [])];

    if (shouldInjectSlackTool(apiInvocation)) {
      let slackToolOption = {
        id: 11,
        third_party_tool_id: apiInvocation?.slackChannel?.value,
        name: "post_report_to_channel"
      };

      if (apiInvocation?.slackChannel?.description !== undefined) {
        slackToolOption.description = apiInvocation?.slackChannel?.description;
      }

      retBlueprintOptions.push(slackToolOption);
    }

    // Filtering out the memory option from tools if user does not have them. Not modifying the state/checkbox of saved agents but
    // figure we need to disable it from function if user should not have it.
    if (!isEnabled("aible-claw-read-memory")) {
      retBlueprintOptions = retBlueprintOptions.filter((option) => option?.id !== "14");
    }

    // Adding checks for cronJob backend Step by Steps, assuming only 1 option for these new backend step agents for now
    const isNewBackendStepAgent =
      retBlueprintOptions?.[0]?.blueprint_id && retBlueprintOptions?.[0]?.value === "step_by_step_agent_tool";

    // this is split out from the test call so it can be reused
    await dispatch(initClawTest(agentId, apiInvocation, appIndex));

    if (isNewBackendStepAgent) {
      const aibleAnywhereProjects = getBase(getState());
      const agent = aibleAnywhereProjects?.[agentId];
      const workFlow = agent?.executionWorkflows?.[retBlueprintOptions?.[0]?.workflow_plan];
      await dispatch(
        chatGPTReducer.handleAgentIQ(
          apiInvocation?.prompt,
          false,
          "step-by-step",
          retBlueprintOptions?.[0]?.executionId,
          agent?.id,
          undefined,
          useCache,
          true,
          workFlow
        )
      );
    } else {
      // Original test behavior
      dispatch(
        chatGPTReducer.handleAgentIQ(
          apiInvocation?.prompt,
          false,
          "reasoning",
          undefined,
          agentId,
          retBlueprintOptions,
          useCache
        )
      );
    }

    return Promise.resolve();
  };
}

export function testCronJob(agentId, cronJob, indexOverride, useCache = false) {
  return async (dispatch, getState) => {
    const cronIndex = indexOverride ?? cronJob?.index;

    const cronJobPrompt = parseCronJobPrompt(getState(), cronJob?.prompt);

    dispatch(updateTestCronIndex(cronIndex));

    let retBlueprintOptions = [...(cronJob?.blueprintOptions ?? [])];

    if (shouldInjectSlackTool(cronJob)) {
      let slackToolOption = {
        id: 11,
        third_party_tool_id: cronJob?.slackChannel?.value,
        name: "post_report_to_channel"
      };

      if (cronJob?.slackChannel?.description !== undefined) {
        slackToolOption.description = cronJob?.slackChannel?.description;
      }

      retBlueprintOptions.push(slackToolOption);
    }

    // Filtering out the memory option from tools if user does not have them. Not modifying the state/checkbox of saved agents but
    // figure we need to disable it from function if user should not have it.
    if (!isEnabled("aible-claw-read-memory")) {
      retBlueprintOptions = retBlueprintOptions.filter((option) => option?.id !== "14");
    }

    // Adding checks for cronJob backend Step by Steps, assuming only 1 option for these new backend step agents for now
    const isNewBackendStepAgent = retBlueprintOptions?.[0]?.workflow_plan && retBlueprintOptions?.[0]?.id === 9;

    // this is split out from the test call so it can be reused
    await dispatch(initClawTest(agentId, cronJob, cronIndex));

    if (isNewBackendStepAgent) {
      const aibleAnywhereProjects = getBase(getState());
      const agent = aibleAnywhereProjects?.[agentId];
      const workFlow = agent?.executionWorkflows?.[retBlueprintOptions?.[0]?.workflow_plan];
      await dispatch(
        chatGPTReducer.handleAgentIQ(
          cronJobPrompt,
          false,
          "step-by-step",
          retBlueprintOptions?.[0]?.executionId,
          agent?.id,
          undefined,
          useCache,
          true,
          workFlow
        )
      );
    } else {
      // Original test behavior
      await dispatch(
        chatGPTReducer.handleAgentIQ(
          cronJobPrompt,
          false,
          cronJob?.executionMetadata?.execution_id !== undefined ? "step-by-step" : "reasoning",
          cronJob?.executionMetadata?.execution_id,
          agentId,
          retBlueprintOptions,
          useCache
        )
      );
    }

    return Promise.resolve();
  };
}

export function parseCronJobPrompt(state, prompt) {
  const chatToneText = chatGPTReducer.getChatToneText(state);

  let cronJobPrompt = prompt ?? "";

  if (!cronJobPrompt.includes("{{CHAT_TONE}}")) {
    cronJobPrompt += "\n\n{{CHAT_TONE}}";
  }

  try {
    cronJobPrompt = cronJobPrompt.replace(/{{CHAT_TONE}}/g, chatToneText);
  } catch (e) {
    console.log(e);
  }

  return cronJobPrompt;
}

export function addMessagesFromAgentCollection(agentId, collectionId) {
  return async (dispatch, getState) => {
    // Grab the activity log
    const activity = getClawActivity(getState(), agentId);
    for (let i = 0; i < activity.length; i++) {
      const cEntry = activity[i];

      // Find the activity associated with the current collection
      if (Number(cEntry?.collectionId) === Number(collectionId)) {
        // generate the question
        const questionIndex = dispatch(
          chatGPTReducer.addMessageConversation(
            {
              user: cEntry.name,
              text: cEntry.query,
              date: cEntry.created_date,
              isQuestion: true,
              alwaysShowStep: true
            },
            undefined,
            true
          )
        );
        // generate the answer

        let retMessage = {
          user: "Aible",
          text: cEntry.response,
          date: cEntry.updated_date,
          questionIndex: questionIndex,
          alwaysShowStep: true
        };

        if (cEntry?.contentGenerationIds !== undefined) {
          retMessage = {
            ...retMessage,
            contentGenerationIds: cEntry?.contentGenerationIds,
            contentGenerationAccount: cEntry?.contentGenerationAccount,
            datasetId: cEntry?.datasetId,
            content_references: cEntry?.content_references,
            blueprintId: "CHATAIBLE_ANALYTICS",
            chatType: "AIBLE",
            response_data: cEntry?.response_data
          };

          await dispatch(homeReducer.fetchDataset(cEntry?.datasetId, undefined, true));
        }

        dispatch(chatGPTReducer.addMessageConversation(retMessage));
      }
    }
    // TODO: Scroll to the bottom after adding all these messages
    // scrollChat(0);
  };
}

// send a message to the cronjob/api invocation specified by the collectionId
export function clawChat(agentId, collectionId, prompt) {
  return async (dispatch, getState) => {
    const accountId = accountsReducer.getSelectedAccountId(getState());
    const currModel = chatGPTReducer.getModelId(getState());
    const currClaw = getAibleAnywhere(getState(), agentId);

    dispatch(chatGPTReducer.updateIsAskingAgent(true));

    let clawChatType = "cronJobs";
    for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
      for (let i = 0; i < currClaw?.[key]?.length; i++) {
        const currJob = currClaw[key][i];
        if (Number(currJob.collection_id) === Number(collectionId)) {
          clawChatType = key;
        }
      }
    }

    const payload_key = ((x) => {
      switch (x) {
        case "cronJobs":
          return "cron_job";
        case "apiInvocations":
          return "api_invocation";
        default:
          return x;
      }
    })(clawChatType);
    const testContent = {
      type: "generate_content",
      generation_config: {
        model: currModel
      },
      messages: [
        {
          role: "user",
          content: prompt
        }
      ],
      tools: [
        {
          type: "blueprint",
          blueprint_id: Number(agentId),
          input_payload: {
            [payload_key]: collectionId
          }
        }
      ]
    };
    let questionIndex;
    try {
      const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
      // Add user prompt to message history
      questionIndex = dispatch(
        chatGPTReducer.addMessageConversation(
          {
            user: "User",
            text: prompt,
            date: new Date(),
            isQuestion: true,
            alwaysShowStep: true
          },
          undefined,
          true
        )
      );
      // creates content generation request
      const completionRequest = await factory.getCompletionClient().generateContent(testContent);
      // await completion result
      const response = await factory
        .getCompletionClient()
        .pollAsyncProcess(completionRequest.id, (id) => factory.getCompletionClient().getCompletion(id));

      // add result to message history
      dispatch(
        chatGPTReducer.addMessageConversation({
          user: "Aible",
          text: response?.data?.output?.content,
          date: new Date(),
          questionIndex: questionIndex,
          alwaysShowStep: true
        })
      );
    } catch (e) {
      dispatch(handleGPTError(e, undefined, undefined, undefined, questionIndex));
    }

    dispatch(chatGPTReducer.updateIsAskingAgent(false));
    return Promise.resolve();
  };
}

export function fetchClawActivity(agentId) {
  return async (dispatch, getState) => {
    dispatch(globalReducer.updateClawActivityLoad(agentId, true));
    const currClaw = getAibleAnywhere(getState(), agentId);

    const accountId = accountsReducer.getSelectedAccountId(getState());
    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);

    let retClaw;
    for (const key of CLAW_COLLECTION_ID_LOCATIONS) {
      for (let i = 0; i < currClaw?.[key]?.length; i++) {
        const currJob = currClaw[key][i];
        if (currJob.collection_id) {
          const executions = await factory.getContentGenerationClient().getCollectionExecutions(currJob.collection_id);
          if (!retClaw) {
            retClaw = { ...currClaw };
          }
          retClaw[key][i].executions = executions;

          // Not used right now since we're injecting the executions into the reducer
          // dispatch(contentGenerationReducer.fetchCollectionById(currJob.collection_id));
        }
      }
    }

    // Only update if we had executions to inject
    if (retClaw) {
      dispatch(updateAibleAnywhere(agentId, retClaw));
    }
    dispatch(globalReducer.updateClawActivityLoad(agentId, false));
  };
}

// given a tool, returns the tool with the guardrails either added or removed
export function modifyGuardrailSettingsOnTool(tool, useGuardrails) {
  return (dispatch, getState) => {
    const retOption = {
      ...tool
    };
    const hasGuardrailOptions = chatGPTReducer.getIsGuardrailsAllowedCTool(getState(), tool);
    // Only modify guardrails for tools that can have guardrails
    if (hasGuardrailOptions) {
      if (useGuardrails) {
        // if its a new option, set input, output, and system instructions
        const defaultInputInstruction = chatGPTReducer.getDefaultGuardrailsInputInstruction(getState());
        const defaultOutputInstruction = chatGPTReducer.getDefaultGuardrailsOutputInstruction(getState());
        const defaultSystemInstruction = chatGPTReducer.getDefaultGuardrailsSystemInstruction(getState());
        const currGuardrails = {
          ...(retOption.guardrails_config ?? {})
        };
        if (!currGuardrails.input_instructions) {
          currGuardrails.input_instructions = defaultInputInstruction;
        }
        if (!currGuardrails.output_instructions) {
          currGuardrails.output_instructions = defaultOutputInstruction;
        }
        if (!currGuardrails.system_instructions) {
          currGuardrails.system_instructions = defaultSystemInstruction;
        }
        retOption.guardrails_config = currGuardrails;
      } else {
        // if turning off, just delete the entire config
        if (retOption.guardrails_config) {
          delete retOption.guardrails_config;
        }
      }
    }
    return retOption;
  };
}

// given new tool selections, a list of current tools, and whether guardrails are on by default
// returns a the new selection with guardrails set to the current default and hidden tools added back in
export function validateClawToolSelection(newSelection, currentOptions, useGuardrails) {
  return (dispatch, getState) => {
    const HIDDEN_TOOLS_IDS = ["14"];
    const hiddenTools = (currentOptions ?? []).filter((option) => HIDDEN_TOOLS_IDS.includes(option?.id));
    let retValue = newSelection ?? [];
    // if useGuardrails is true, default turn on guardrails for any new selections
    if (useGuardrails) {
      retValue = retValue.map((bpOption) => {
        let retOption = bpOption;
        const isNewOption = !currentOptions?.find((o) => retOption?.id === o?.id);
        // Only modify guardrails for bpOptions that can have guardrails and are new without default guardrail settings
        if (isNewOption && !bpOption?.guardrails_config) {
          retOption = dispatch(modifyGuardrailSettingsOnTool(bpOption, useGuardrails));
        }
        return retOption;
      });
    }
    const updatedOptions = [...retValue, ...hiddenTools];

    return updatedOptions;
  };
}

export function addAibleAnywhereMessage(message) {
  return (dispatch, getState) => {
    const id = chatGPTReducer.getSelectedAAProject(getState());

    let aibleAnywhere = getAibleAnywhere(getState(), id);

    console.log("what is aa", aibleAnywhere);

    aibleAnywhere.messages = [...(aibleAnywhere?.messages ?? []), message];

    dispatch(updateAibleAnywhere(id, aibleAnywhere));

    const agentScroller = document.getElementById("agent_message_scroll");
    if (agentScroller) {
      setTimeout(() => {
        agentScroller.scrollTo({ top: agentScroller.scrollHeight, behavior: "smooth" });
      }, 200);
    }
  };
}

export function regenStep(id, userPrompt, stepIndex) {
  return async (dispatch, getState) => {
    dispatch(chatGPTReducer.updateSelectedAAProject(id));
    const aaProject = getAibleAnywhere(getState(), id);

    const genStep = aaProject?.steps?.[stepIndex];
    const parsedFields = undefined;

    if (genStep === undefined) {
      return Promise.resolve();
    }

    const nGenStep = {
      datasetId: genStep?.DatasetId,
      gen_prompt: genStep?.Plan,
      type: genStep?.Type
    };

    console.log("what is genStep?", nGenStep);

    dispatch(updateIsRegenLoading("misc", true));

    const nStep = await dispatch(
      generateAAStep(getState(), userPrompt, nGenStep, parsedFields, aaProject?.generate_outline)
    );

    console.log("regenStep nStep", nStep);

    aaProject.steps[stepIndex] = nStep;

    dispatch(updateAibleAnywhere(id, aaProject));

    dispatch(updateIsRegenLoading("misc", false));
  };
}

const EXAMPLE_DATASETS = "";
const EXAMPLE_OUTLINE = "";

export function generateSuggestQuestion() {
  return async (dispatch, getState) => {
    const datasets = homeReducer.getDatasets(getState());
    const reports = reportReducer.getReports(getState());

    const datasetsJSON = Object.keys(datasets).map((d) => ({
      name: datasets[d].label,
      id: datasets[d].id,
      fields: Object.keys(datasets[d].fields).map((f) => f)
    }));

    console.log("what are EXAMPLE_DATASETS", JSON.stringify(datasetsJSON));

    const modelsJSON = reports
      .filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined)
      .map((r) => ({
        name: r?.name,
        projectId: r?.metadata?.explorations?.[0]?.projectId,
        datasetId: r?.metadata?.explorations?.[0]?.datasetId
      }));

    const suggestPrompt =
      `I'm going to give you a list of Example Datasets, with an Example User Prompt that is used to generate an Example Outline which will help to answer the Example User Prompt.
I'll then give you a list of Actual Datasets and I'd like for you to generate some other possible interesting User Prompts that would be possible to solve.
Try to have these distinct from the Example User Prompt!

Please return the Suggested User Prompts as an Array List like ["", "", ""], thanks!

Example Datasets:
` +
      JSON.stringify(AA_Examples.EXAMPLE_DATASETS_GAMING) +
      `

Example User Prompt:
` +
      AA_Examples.OUTLINE_BUILDER_GAMING?.prompt +
      `

Example Outline:
` +
      JSON.stringify(AA_Examples.OUTLINE_BUILDER_GAMING) +
      `

Actual Datasets:
` +
      JSON.stringify(datasetsJSON) +
      `

Suggested User Prompts:
`;

    console.log("what is suggestPrompt", suggestPrompt);

    const suggestResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: suggestPrompt }],
        temperature: 1,
        frequency_penalty: 0,
        presence_penalty: 0
      })
    );

    console.log("what is response? ", suggestResponse?.data?.output?.content);

    const suggestJson = JSON.parse(suggestResponse?.data?.output?.content);

    dispatch(updateSuggestPrompts("misc", suggestJson));

    console.log("what is suggestResponse", suggestResponse, suggestJson);

    return Promise.resolve();
  };
}

export function parseClawGenerationPrompt(state, prompt, userPrompt, slackChannels = []) {
  let retGenerationPrompt = prompt ?? "";
  if (!prompt.includes("{{CHAT_PROMPT}}")) {
    retGenerationPrompt += "\n{{CHAT_PROMPT}}";
  }

  // Using custom parsing for claw generation
  let retPrompt = retGenerationPrompt;

  try {
    const blueprintToolOptions = chatGPTReducer.getAgentCTools(state);
    const uniqueIdToolOptions = chatGPTReducer.getAgentCUniqueToolGenOptions(state, blueprintToolOptions);

    const communicationOptions = chatGPTReducer.getAgentCCommunicationOptions(state);

    const reports = viewReducer.getReports(state);

    const optimizeReports = (reports ?? [])?.filter(
      (r) =>
        Object.keys(r?.metadata?.models?.beforeSetup ?? {}).length > 0 ||
        r?.metadata?.chatGPTConvo?.optimizeSetup !== undefined
    );

    const reportOptions = (optimizeReports ?? []).map((o) => ({
      name: o?.metadata?.explorations?.[0]?.reportLabel ?? o?.name,
      id: o?.id
    }));

    const retUserPrompt = userPrompt ?? "";
    retPrompt = retPrompt
      .replace(/{{CHAT_PROMPT}}/g, retUserPrompt)
      .replace(/{{TOOL_OPTIONS}}/g, JSON.stringify(uniqueIdToolOptions))
      .replace(/{{COMMUNICATION_OPTIONS}}/g, JSON.stringify(communicationOptions))
      .replace(/{{SLACK_CHANNELS}}/g, JSON.stringify(slackChannels))
      .replace(/{{OPTIMIZE_REPORTS}}/g, JSON.stringify(reportOptions));

    console.log("parsePrompt", prompt, communicationOptions, reportOptions);
  } catch (e) {
    console.log(e);
  }

  return retPrompt;
}

export function generateAgentC(userPrompt) {
  return async (dispatch, getState) => {
    try {
      console.log("-=-=-=-=-=- generating\n\n", userPrompt);

      const accountId = accountsReducer.getSelectedAccountId(getState());

      const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
      const slackChannels = isEnabled("aible-claw-external-communication-options")
        ? await factory.getCompletionClient().getTools()
        : [];
      const retSlackChannels = (slackChannels ?? []).map((sc) => ({ label: sc?.config?.channel_id, value: sc?.id }));

      const blueprintToolOptions = chatGPTReducer.getAgentCTools(getState());

      const communicationOptions = chatGPTReducer.getAgentCCommunicationOptions(getState());

      const rawGenerationPrompt = chatGPTReducer.getClawAgentGenerationPrompt(getState(), true);
      const rawGenerationCronJobsPrompt = chatGPTReducer.getClawAgentGenerationCronJobsPrompt(getState(), true);
      const rawGenerationApiInvocationsPrompt = chatGPTReducer.getClawAgentGenerationApiInvocationsPrompt(
        getState(),
        true
      );

      const generationPrompt = parseClawGenerationPrompt(getState(), rawGenerationPrompt, userPrompt, retSlackChannels);
      const generationCronJobsPrompt = parseClawGenerationPrompt(
        getState(),
        rawGenerationCronJobsPrompt,
        userPrompt,
        retSlackChannels
      );
      const generationApiInvocationsPrompt = parseClawGenerationPrompt(
        getState(),
        rawGenerationApiInvocationsPrompt,
        userPrompt,
        retSlackChannels
      );

      const generationPayload = {
        messages: [{ role: "user", content: generationPrompt }],
        generation_config: {
          ...chatGPTReducer.getGenerationConfig(getState()),
          temperature: 0.2,
          max_tokens: 8000,
          presence_penalty: 0,
          output_format: {
            type: "json",
            json_schema: {
              additionalProperties: false,
              properties: {
                name: {
                  title: "Name",
                  type: "string"
                },
                description: {
                  title: "Description",
                  type: "string"
                }
              },
              required: ["name", "description"],
              title: "AgentOutput",
              type: "object"
            }
          }
        }
      };

      const generationPayloadBlueprintOptions = {
        description: "Selected tools (symbolic keys) and optional per-job tool usage instructions.",
        items: {
          anyOf: [
            {
              additionalProperties: false,
              description:
                'LLM-facing tool selection entry.\n\n- key: stable symbolic tool key (e.g., "t6", "t10")\n- description: optional per-agent override / task-specific instruction for downstream agent',
              properties: {
                id: {
                  description: 'Tool key, e.g. "t6" or "t10". Must be one of the allowed keys.',
                  title: "Id",
                  type: "string"
                },
                description: {
                  anyOf: [
                    {
                      type: "string"
                    },
                    {
                      type: "null"
                    }
                  ],
                  default: null,
                  description: "Optional task-specific override/instruction for how to use this tool in this cron job.",
                  title: "Description"
                }
              },
              required: ["id"],
              title: "BlueprintOption",
              type: "object"
            },
            {
              additionalProperties: false,
              description:
                'LLM-facing tool selection entry.\n\n- key: stable symbolic tool key (e.g., "t6", "t10")\n- description: optional per-agent override / task-specific instruction for downstream agent',
              properties: {
                id: {
                  description: 'Tool key, e.g. "t6" or "t10". Must be one of the allowed keys.',
                  title: "Id",
                  type: "string"
                },
                description: {
                  anyOf: [
                    {
                      type: "string"
                    },
                    {
                      type: "null"
                    }
                  ],
                  default: null,
                  description: "Optional task-specific override/instruction for how to use this tool in this cron job.",
                  title: "Description"
                },
                value: {
                  type: "string",
                  title: "Value",
                  enum: ["prediction_tool"]
                },
                predictNextId: {
                  type: "number",
                  description: "The id from the PREDICTION DATA OPTIONS that matches with the prediciton tool",
                  title: "predictNextId"
                }
              },
              required: ["id", "predictNextId", "value"],
              title: "BlueprintOption",
              type: "object"
            }
          ]
        },
        title: "Blueprintoptions",
        type: "array"
      };

      const generationCronJobsPayload = {
        messages: [{ role: "user", content: generationCronJobsPrompt }],
        generation_config: {
          ...chatGPTReducer.getGenerationConfig(getState()),
          temperature: 0.2,
          max_tokens: 8000,
          presence_penalty: 0,
          output_format: {
            type: "json",
            json_schema: {
              additionalProperties: false,
              properties: {
                cronJobs: {
                  items: {
                    additionalProperties: false,
                    properties: {
                      blueprintOptions: generationPayloadBlueprintOptions,
                      communicationOptions: {
                        description: "Optional selected extra communication methods.",
                        items: {
                          title: "CommunicationOption",
                          type: "string"
                        },
                        title: "CommunicationOptions",
                        type: "array"
                      },
                      prompt: {
                        title: "Prompt",
                        type: "string"
                      },
                      timezone: {
                        title: "Timezone",
                        type: "string"
                      },
                      cron_expr: {
                        title: "Cron Expr",
                        type: "string"
                      },
                      slackChannel: {
                        anyOf: [
                          {
                            additionalProperties: false,
                            properties: {
                              label: {
                                title: "Label",
                                type: "string"
                              },
                              value: {
                                title: "Value",
                                type: "string"
                              },
                              description: {
                                description:
                                  "Optional task-specific override/instruction for how to use this communication method.",
                                title: "Description",
                                type: "string"
                              }
                            },
                            required: ["label", "value", "description"],
                            title: "SlackChannel",
                            type: "object"
                          },
                          {
                            type: "null"
                          }
                        ],
                        default: null
                      }
                    },
                    required: ["blueprintOptions", "communicationOptions", "prompt", "timezone", "cron_expr"],
                    title: "CronJob",
                    type: "object"
                  },
                  title: "Cronjobs",
                  type: "array"
                }
              },
              required: ["cronJobs"],
              title: "AgentOutput",
              type: "object"
            }
          }
        }
      };

      const generationApiInvocationsPayload = {
        messages: [{ role: "user", content: generationApiInvocationsPrompt }],
        generation_config: {
          ...chatGPTReducer.getGenerationConfig(getState()),
          temperature: 0.2,
          max_tokens: 8000,
          presence_penalty: 0,
          output_format: {
            type: "json",
            json_schema: {
              additionalProperties: false,
              properties: {
                apiInvocations: {
                  items: {
                    additionalProperties: false,
                    properties: {
                      api_hook_event_name: {
                        description: 'Name of the API hook event in snake-case, e.g. "request_expedite_order".',
                        title: "Api Hook Event Name",
                        type: "string"
                      },
                      blueprintOptions: generationPayloadBlueprintOptions,
                      communicationOptions: {
                        description: "Optional selected extra communication methods.",
                        items: {
                          title: "CommunicationOption",
                          type: "string"
                        },
                        title: "CommunicationOptions",
                        type: "array"
                      },
                      prompt: {
                        title: "Prompt",
                        type: "string"
                      },
                      slackChannel: {
                        anyOf: [
                          {
                            additionalProperties: false,
                            properties: {
                              label: {
                                title: "Label",
                                type: "string"
                              },
                              value: {
                                title: "Value",
                                type: "string"
                              },
                              description: {
                                description:
                                  "Optional task-specific override/instruction for how to use this communication method.",
                                title: "Description",
                                type: "string"
                              }
                            },
                            required: ["label", "value", "description"],
                            title: "SlackChannel",
                            type: "object"
                          },
                          {
                            type: "null"
                          }
                        ],
                        default: null
                      }
                    },
                    required: ["api_hook_event_name", "blueprintOptions", "communicationOptions", "prompt"],
                    title: "ApiInvocation",
                    type: "object"
                  },
                  type: "array",
                  title: "Apiinvocations"
                }
              },
              required: ["apiInvocations"],
              title: "AgentOutput",
              type: "object"
            }
          }
        }
      };

      const generationPromises = [
        dispatch(chatGPTReducer.doCompletionDefault(generationPayload, true)),
        dispatch(chatGPTReducer.doCompletionDefault(generationCronJobsPayload, true)),
        dispatch(chatGPTReducer.doCompletionDefault(generationApiInvocationsPayload, true))
      ];

      const resultsArray = await Promise.all(generationPromises);
      console.log("-=-=-=-=-=-=-=- generation complete", resultsArray);
      const genResult = resultsArray[0];
      const genCronjobsResult = resultsArray[1];
      const genApiResult = resultsArray[2];

      const genJson = extractJsonFromString(genResult?.data?.output?.content);

      const genCronJobsJson = extractJsonFromString(genCronjobsResult?.data?.output?.content);
      const genApiJson = extractJsonFromString(genApiResult?.data?.output?.content);

      console.log("-=-=-=-=-=-=- jsons", genJson, genCronJobsJson, genApiJson);

      const fixJSON = {
        ...genJson,
        cronJobs: genCronJobsJson?.cronJobs,
        apiInvocations: genApiJson?.apiInvocations
      };

      const matchExistingCommunicationOption = (cOption) => {
        return communicationOptions.find((clawCommOption) => {
          // Currently matching slack option just by label, generated value is our slack data. Just check the option has both label and value.

          if (cOption === clawCommOption.label || cOption === clawCommOption.value) {
            return true;
          }

          return false;
        });
      };
      console.log("what is genAgentReponse fixJSON", fixJSON);

      // MB: We should add any more validation that's needed for these response objects here.
      const validatedApiInvocations = (fixJSON.apiInvocations ?? []).map((invocation) => {
        const validatedJobBlueprintOptions = (invocation?.blueprintOptions ?? [])
          .map((bpOption) => {
            const agentCUniqueToolById = dispatch(
              chatGPTReducer.getAgentCUniqueToolById(blueprintToolOptions, bpOption, invocation)
            );
            return agentCUniqueToolById;
          })
          .filter((v) => v);
        const predictNextId = validatedJobBlueprintOptions.find((op) => {
          if (op?.value === "prediction_tool" && op.predictNextId) {
            return true;
          }
          return false;
        })?.predictNextId;

        const apiHookName = invocation?.api_hook_event_name;
        let validatedApiIntervalOptions = [];

        const newIntervalOption = {
          label: apiHookName,
          value: apiHookName,
          __isNew__: true
        };

        if (apiHookName) {
          validatedApiIntervalOptions.push(newIntervalOption);
        }

        const validatedCommunicationOptions = (invocation.communicationOptions ?? [])
          .map((cOption) => {
            const matchedCommunicationOption = matchExistingCommunicationOption(cOption);

            if (matchedCommunicationOption === undefined) {
              return undefined;
            }

            const retOption = {
              ...matchedCommunicationOption
            };

            return retOption;
          })
          .filter((v) => v);

        const retApiInvocation = {
          ...invocation,
          predictNextId: predictNextId,
          blueprintOptions: validatedJobBlueprintOptions,
          communicationOptions: validatedCommunicationOptions,
          intervalOptions: validatedApiIntervalOptions,
          prompt: invocation?.prompt ?? ""
        };

        if (invocation?.predictNextId) {
          retApiInvocation.predictNextId = invocation.predictNextId;
        }

        return retApiInvocation;
      });

      const validatedCronJobs = (fixJSON.cronJobs ?? []).map((job) => {
        const validatedJobBlueprintOptions = (job?.blueprintOptions ?? [])
          .map((bpOption) => {
            const agentCUniqueToolById = dispatch(
              chatGPTReducer.getAgentCUniqueToolById(blueprintToolOptions, bpOption, job)
            );
            return agentCUniqueToolById;
          })
          .filter((v) => v);
        const predictNextId = validatedJobBlueprintOptions.find((op) => {
          if (op?.value === "prediction_tool" && op.predictNextId) {
            return true;
          }
          return false;
        })?.predictNextId;

        const validatedCommunicationOptions = (job.communicationOptions ?? [])
          .map((cOption) => {
            const matchedCommunicationOption = matchExistingCommunicationOption(cOption);

            if (matchedCommunicationOption === undefined) {
              return undefined;
            }

            const retOption = {
              ...matchedCommunicationOption
            };

            return retOption;
          })
          .filter((v) => v);

        let validateCronExpr = job.cron_expr;
        try {
          const cronExpr = validateExpression(validateCronExpr);
        } catch (e) {
          console.log(e);
          validateCronExpr = "0 0 * * *";
        }

        const assertTimezoneIsValid = (timeZone) => {
          new Date().toLocaleString("en-US", { timeZone: timeZone });
        };

        let validateTimeZone = job.timezone;
        try {
          assertTimezoneIsValid(validateTimeZone);
        } catch (e) {
          validateTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }

        const retCronJob = {
          ...job,
          predictNextId: predictNextId,
          timezone: validateTimeZone,
          cron_expr: validateCronExpr,
          blueprintOptions: validatedJobBlueprintOptions,
          communicationOptions: validatedCommunicationOptions
        };

        if (job?.predictNextId) {
          retCronJob.predictNextId = job.predictNextId;
        }

        return retCronJob;
      });

      const validatedFixJson = {
        ...fixJSON,
        cronJobs: validatedCronJobs,
        apiInvocations: validatedApiInvocations
      };

      console.debug("generatedAgentC", {
        generatedJSON: fixJSON,
        validated: validatedFixJson
      });

      return validatedFixJson;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
}

export function generateAAStep(state, userPrompt, genStep, parsedFields, genOutline) {
  return async (dispatch, getState) => {
    const datasets = homeReducer.getDatasets(state);
    const reports = reportReducer.getReports(state);

    console.log("what are datasets?", datasets, reports, genStep, parsedFields, genOutline);

    const datasetsJSON = Object.keys(datasets).map((d) => ({
      name: datasets[d].label,
      datasetId: datasets[d].id,
      fields: Object.keys(datasets[d].fields).map((f) => f)
    }));

    const modelsJSON = reports
      .filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined)
      .map((r) => ({
        name: r?.name,
        projectId: r?.metadata?.explorations?.[0]?.projectId,
        datasetId: r?.metadata?.explorations?.[0]?.datasetId
      }));

    const fExampleGen = AA_Examples.OUTLINE_BUILDER_GAMING.generate_steps.find((s) => s?.type === genStep?.type);

    const rGen = AA_Examples.FULL_BUILDER_GAMING.steps.find((s) => s?.Type === genStep?.type);

    console.log("genAAstep", genStep, fExampleGen, rGen);

    const step_outline =
      `Let’s create an Action Step which will play a part in answering our User Prompt.
	I'll give you an example so you can understand what the Response Action Step object looks like and what fields are needed.
	The keys required in the object are '` +
      Object.keys(rGen) +
      `', please use and match them exactly.
	Please also match the {{step_x.field}} format in the Response Prompt so I can parse it later for the correct values.
	Use Datasets and datasetIds that are in the Real Datasets section for your Real Response.
  Return the JSON Action Step using JSON markdown, thanks!
	` +
      (genStep?.type === "Prediction"
        ? `
	Prediction Models:
	` + JSON.stringify(modelsJSON)
        : "") +
      `

	Example User Prompt:
	Who should I focus on hiring to maximize my revenue?

	Example Datasets:
	` +
      JSON.stringify(AA_Examples.EXAMPLE_DATASETS_GAMING) +
      /*
	Example Parsed Fields:
	` +
			JSON.stringify(EXAMPLE_INTENT) +
			/*
			`

	Example Outline:
	` +
			JSON.stringify(OUTLINE_BUILDER) +
			*/
      `

	Example Action Generate:
	` +
      JSON.stringify(fExampleGen) +
      `

	Example Response:
	` +
      JSON.stringify(rGen) +
      `

	Real:
	User Prompt:
	` +
      userPrompt +
      `

	Real Datasets:
	` +
      JSON.stringify(datasetsJSON) +
      `

	Outline:
	` +
      JSON.stringify(genOutline) +
      `

	Action Generate:
	` +
      JSON.stringify(genStep) +
      `

	Real Response:
	`;

    console.log("what is step_outline", step_outline);

    dispatch(
      addAibleAnywhereMessage({
        text: "Generating Step of Type: " + genStep?.type,
        prompt: step_outline
      })
    );

    const stepResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: step_outline }],
        temperature: 1,
        frequency_penalty: 0,
        presence_penalty: 0
      })
    );

    dispatch(
      addAibleAnywhereMessage({
        text: "Step Completed: " + genStep?.type,
        prompt: stepResponse?.data?.output?.content
      })
    );

    const fixJSON = extractJsonFromString(stepResponse?.data?.output?.content);

    return fixJSON;
  };
}

export function generateIntent(state, userPrompt) {
  return async (dispatch, getState) => {
    const datasets = homeReducer.getDatasets(state);
    const datasetsJSON = Object.keys(datasets).map((d) => ({
      name: datasets[d].label,
      datasetId: datasets[d].id,
      fields: Object.keys(datasets[d].fields).map((f) => ({
        [f]:
          datasets[d].fields[f]?.data !== undefined
            ? [
                datasets[d].fields[f]?.data?.[0]?.value,
                datasets[d].fields[f]?.data?.[datasets[d].fields[f].data.length - 1]?.value
              ]
            : []
      }))
    }));

    const INTENT_PROMPT =
      `Parse the following User Prompt using this list of Datasets Fields, find any fields with values that might match what the User Prompt is talking about.
	Include any fields that you may think fit, we will filter out the incorrect ones later!
	Give me this back as a raw JSON object. I'll give you an Example so you can understand the format of the response.
	You may also include other fields in the response object like quantity if you parse it from the User Prompt.
	The response must be only JSON, no additional markdown or text.

	Datasets:
	` +
      JSON.stringify(AA_Examples.EXAMPLE_DATASETS_GAMING) +
      `

	Example User Prompt:
	I'd like to hire more people for my Live Services team.

	Example Response:
	` +
      JSON.stringify(AA_Examples.EXAMPLE_INTENT_GAMING) +
      `

	User Prompt:
	` +
      userPrompt;

    console.log("what is INTENT_PROMPT", INTENT_PROMPT);

    const intentResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: INTENT_PROMPT }]
      })
    );

    console.log("what is intent response".intentResponse);

    try {
      const genIntent = JSON.parse(intentResponse?.data?.output?.content);

      return genIntent;
    } catch (e) {
      console.log("parsing generate genIntent failed", e);
    }
  };
}

export function generateAAFull(userPrompt) {
  return async (dispatch, getState) => {
    dispatch(updateIsLoading("misc", true));

    dispatch(updateBase({ ...getBase(getState()), ["generate_new_agent"]: { prompt: userPrompt } }));

    dispatch(chatGPTReducer.updateSelectedAAProject("generate_new_agent"));

    dispatch(push("agent/generate_new_agent"));

    dispatch(
      addAibleAnywhereMessage({
        text: "Generating new Agent using the prompt: " + userPrompt
      })
    );

    const outlineResponse = await dispatch(generateAAOutline(userPrompt));

    console.log("generateAAFull what is outlineResponse", outlineResponse);

    const fullProjectResponse = await dispatch(generateAAProjectFromOutline(userPrompt, outlineResponse));

    dispatch(
      addAibleAnywhereMessage({
        text: "Agent Completed!",
        response: fullProjectResponse
      })
    );

    dispatch(updateIsLoading("misc", false));

    console.log("generateAAFull what is fullProjectResponse", fullProjectResponse);
  };
}

export function generateAAOutline(userPrompt) {
  return async (dispatch, getState) => {
    //const intentResponse = await dispatch(generateIntent(getState(), userPrompt));
    const datasets = homeReducer.getDatasets(getState());
    const reports = reportReducer.getReports(getState());
    const artifacts = languageModelArtifactReducer.getCorpusList(getState());

    console.log("what are datasets?", datasets, artifacts);

    const datasetsJSON = Object.keys(datasets).map((d) => ({
      name: datasets[d].label,
      id: datasets[d].id,
      fields: Object.keys(datasets[d].fields).map((f) => f),
      outcome: datasets[d]?.outcome
    }));

    artifacts !== undefined &&
      artifacts.forEach((art) => {
        datasetsJSON.push({
          name: art?.name,
          artifactId: art?.id
        });
      });

    console.log("what are datasets?", datasets, reports, artifacts);

    const modelsJSON = reports
      .filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined)
      .map((r) => ({
        name: r?.name,
        projectId: r?.metadata?.explorations?.[0]?.projectId,
        datasetId: r?.metadata?.explorations?.[0]?.datasetId
      }));

    const gen_outline =
      `Let’s create an Outline which can contain multiple steps to better answer our User Prompt.
Each step I’ll allow you to do a Document Search for data, query data either in the form of a NLQ or we can make Predictions using other models.
I'll give you an Action Type Description to define better define all of these Actions. Please try to include a Document Search in the beginning if possible.
I’ll show you an example so you understand the format and what’s required, then please respond under the Real Example Response section.

Example User Prompt:
Who should I focus on hiring to maximize my revenue?


Action Type Description:
` +
      JSON.stringify(AIBLE_ANYWHERE_STEP_DESCRIPTION) +
      `
Example Datasets:
` +
      JSON.stringify(AA_Examples.EXAMPLE_DATASETS_GAMING) +
      /*
`
Example Parsed Fields:
` +
			JSON.stringify(AA_Examples.EXAMPLE_INTENT_GAMING) +
*/

      `
Example Response:
` +
      JSON.stringify(AA_Examples.OUTLINE_BUILDER_GAMING) +
      `
** Real Question Below ***
Datasets:
` +
      JSON.stringify(datasetsJSON) +
      `
Prediction Models:
` +
      JSON.stringify(modelsJSON) +
      `
User Prompt:
` +
      userPrompt +
      `
Response:
`;

    console.log("what is gen_outline", gen_outline, JSON.stringify(gen_outline));

    dispatch(
      addAibleAnywhereMessage({
        text: "Generating Agent Outline",
        prompt: gen_outline
      })
    );

    const outlineResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: gen_outline }]
      })
    );

    dispatch(
      addAibleAnywhereMessage({
        text: "Agent Outline Completed",
        response: outlineResponse?.data?.output?.content
      })
    );

    try {
      const genProject = extractJsonFromString(outlineResponse?.data?.output?.content);

      console.log("new aa project!", genProject);

      const oBase = getBase(getState());

      const nKey = chatGPTReducer.getSelectedAAProject(getState());

      const retProject = { ...oBase[nKey], ...genProject };

      dispatch(
        updateBase({
          ...oBase,
          [nKey]: retProject
        })
      );

      //dispatch(chatGPTReducer.updateSelectedAAProject(nKey));

      //dispatch(generateAAProjectFromOutline(userPrompt, genProject));

      return retProject;
    } catch (e) {
      console.log("parsing generate project failed", e);
    }

    console.log("what is gen response?", outlineResponse);
  };
}

export function extractJsonFromString(input) {
  try {
    // Try to find the start of a ```json block
    const jsonBlockStart = input.indexOf("```json");

    if (jsonBlockStart !== -1) {
      // Find the end of the code block
      const jsonBlockEnd = input.indexOf("```", jsonBlockStart + 7);
      if (jsonBlockEnd !== -1) {
        const jsonString = input.slice(jsonBlockStart + 7, jsonBlockEnd).trim();
        return JSON.parse(jsonString);
      }
    }

    // If no ```json block, try parsing the whole string
    return JSON.parse(input.trim());
  } catch (e) {
    console.error("Failed to parse JSON:", e, input);
    return null;
  }
}

export function generateAAProjectFromOutline(userPrompt, genOutline) {
  return async (dispatch, getState) => {
    const oBase = getBase(getState());
    const nKey = genOutline?.name + Object.keys(oBase ?? {}).length;

    console.log("what is gen generateAAProjectFromOutline userPrompt genOutline/", userPrompt, genOutline);

    let nProject = {
      name: genOutline?.name,
      steps: [],
      generate_steps: genOutline?.generate_steps,
      generate_outline: genOutline
    };

    for (const gen_step of genOutline?.generate_steps) {
      const fStep = await dispatch(
        generateAAStep(getState(), userPrompt, gen_step, genOutline?.parsedFields, nProject?.steps)
      );
      nProject.steps.push({ ...fStep, Plan: gen_step?.gen_prompt });

      console.log("wat is nProject?", nProject);
    }

    const aaProject = chatGPTReducer.getSelectedAAProject(getState());

    dispatch(updateBase({ ...oBase, [aaProject]: { ...oBase?.[aaProject], ...nProject } }));
  };
}

export async function generateAAProject(userPrompt) {
  return async (dispatch, getState) => {
    const datasets = homeReducer.getDatasets(getState());

    console.log("what are datasets?", datasets);

    const datasetsJSON = Object.keys(datasets).map((d) => ({
      name: datasets[d].label,
      id: datasets[d].id,
      fields: Object.keys(datasets[d].fields).map((f) => f)
    }));

    const gen_outline =
      `Let’s create an Outline which can contain multiple steps to better answer our User Prompt.
Each step I’ll allow you to query data either in the form of a NLQ or we can make predictions against certain models.
I’ll show you an example so you understand the format and what’s required, then please respond under the Real Example Response section.
Please match the {{step_x.field}} format in the Response Prompt so I can parse it later for the correct values. Thanks!

Datasets:
` +
      JSON.stringify(datasetsJSON) +
      `

Response:
` +
      JSON.stringify(TEST_STEPS) +
      `
Real Example:
User Prompt:
` +
      userPrompt +
      `
Response:
`;

    console.log("what is gen_outline", gen_outline);

    const outlineResponse = await dispatch(
      chatGPTReducer.doCompletionDefault({
        messages: [{ role: "user", content: gen_outline }]
      })
    );

    console.log("what is outlineResponse", outlineResponse);

    try {
      const genProject = JSON.parse(outlineResponse?.data?.output?.content);

      console.log("new aa project!", genProject);

      const oBase = getBase(getState());

      const nKey = chatGPTReducer.getSelectedAAProject(getState());

      dispatch(
        updateBase({
          ...oBase,
          [nKey]: genProject
        })
      );

      //dispatch(chatGPTReducer.updateSelectedAAProject(nKey));

      return genProject;
    } catch (e) {
      console.log("parsing generate project failed", e);
    }

    console.log("what is gen response?", outlineResponse);
  };
}

export const BACKEND_STEP_TYPE_OPTIONS = [
  { label: "NLQ", value: "dataset_nlq" },
  { label: "Document Summary", value: "summarize_document" },
  { label: "Analytics", value: "analyze_dataset" },
  { label: "Prediction", value: "prediction_tool" },
  { label: "What's Changed", value: "whats_changed" },
  { label: "Publish Report to Slack", value: "post_report_to_channel" },
  { label: "Deep Research", value: "deep_research" },
  //{ label: "Create Derived Feature", value: "create_derived_feature" },
  //{ label: "Dataset Join", value: "perform_left_join" },
  { label: "Search The Web", value: "web_researcher_tool" }
];

export function getBackEndStepIcon(stepName) {
  if (stepName === "Analytics" || stepName === CHATAIBLE_BLUEPRINTS.CHATAIBLE_ANALYTICS.name) {
    return AnalyticsStepIcon;
  }

  if (stepName === "NLQ" || stepName === CHATAIBLE_SQL.name) {
    return NlqStepIcon;
  }

  if (stepName === "Document Summary" || stepName === CHATAIBLE_DOCUMENT_SUMMARIZATION.name) {
    return DocumentSummaryStepIcon;
  }

  if (stepName === "Prediction") {
    return PredictionStepIcon;
  }

  if (stepName === "What's Changed") {
    return WhatsChangedStepIcon;
  }

  if (stepName === "Publish Report to Slack") {
    return SlackStepIcon;
  }

  if (stepName === "Deep Research") {
    return DeepResearchStepIcon;
  }

  if (stepName === "Search The Web") {
    return WebSearchStepIcon;
  }

  if (stepName === "Action Tree") {
    return ActionTreeStepIcon;
  }

  if (stepName === "API Endpoint") {
    return ApiStepIcon;
  }

  if (stepName === "Anything") {
    return AnythingStepIcon;
  }

  if (stepName === "Attach File") {
    return FileAttachIcon;
  }

  if (stepName === "Upload File") {
    return FileAttachIcon;
  }

  if (stepName === "Synthesize") {
  }

  return ThinkingStepIcon;
}

export function getBackendStepLabel(step, foundTool) {
  if (foundTool) {
    if (foundTool?.id === 20 && step?.input_args?.skill_name !== undefined) {
      return getBackendStepLabelFromSkillname(step?.input_args?.skill_name);
    }
    return foundTool?.label;
  } else if (step?.type === "synthesize") {
    return "Synthesize";
  }

  return undefined;
}

export function getBackendStepLabelFromSkillname(skillName) {
  if (skillName === "aiq-research") {
    return "AIQ Research";
  }

  return skillName
    .split(/[-_]/)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}

export function getStepTypeFromBackendStep(backendStepToolName) {
  const retType = BACKEND_STEP_TYPE_OPTIONS.find((s) => s.value === backendStepToolName);
  return retType?.label;
}

export function generateWorkflow(message) {
  return async (dispatch, getState) => {
    console.log("generateWorkflow mesasge", message);

    dispatch(globalReducer.updateIsCreatingStepByStepAgent(true));

    const executionId = chatGPTReducer.getAgentIQExecutionId(getState());

    const account = accountsReducer.getSelectedAccount(getState());
    const acf = await AibleClientFactory.getInstance().getAccountClient().getAgentClientFactory(account.id);
    const agentClient = acf.getAgentExecutionClient();

    const executionMetadata = await agentClient.getExecutionMetadata(executionId, true);

    const testCronIndex = getTestCronIndex(getState());
    const genAgent = { ...(getGenerateAgentC(getState()) ?? {}) };

    if (genAgent?.cronJobs?.[testCronIndex] !== undefined) {
      genAgent.cronJobs[testCronIndex] = {
        ...(genAgent?.cronJobs?.[testCronIndex] ?? {}),
        executionMetadata: executionMetadata
      };

      dispatch(globalReducer.updateIsCreatingStepByStepAgent(false));

      return dispatch(updateGenerateAgentC(genAgent));
    }

    dispatch(viewReducer.updateAgentAutonomyView("LOW"));
    dispatch(viewReducer.handleAgentAutonomyView("LOW"));

    let retAibleBuilder = {
      name: executionMetadata?.data?.name ?? "New Aible Workflow",
      description: executionMetadata?.data?.description ?? "Auto generated Workflow from Agent IQ",
      isAibleAgent: true,
      steps: [],
      execution_steps: executionMetadata?.data?.steps,
      tool_list: executionMetadata?.data?.tool_list,
      executionId: executionId,
      runToggle: "BACKEND",
      workflowOrigin: "AIQ"
    };

    Object.keys(message?.agent_iq?.allContent ?? {}).forEach((aKey) => {
      const agentStep = message.agent_iq.allContent?.[aKey];

      if ((agentStep?.name ?? "").indexOf("dataset_nlq") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }

        if (
          retAibleBuilder?.steps?.find(
            (s) => Number(s?.DatasetId) === Number(parsedObj?.dataset_id) && s?.Original_Query === parsedObj?.query
          ) === undefined
        ) {
          retAibleBuilder?.steps.push({
            Type: "NLQ",
            Title: "NLQ: " + parsedObj?.dataset_id,
            DatasetId: parsedObj?.dataset_id,
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      if ((agentStep?.name ?? "").indexOf("summarize_document") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }
        if (
          retAibleBuilder?.steps?.find(
            (s) => Number(s?.ArtifactId) === Number(parsedObj?.doc_id) && s?.Original_Query === parsedObj?.query
          ) === undefined
        ) {
          retAibleBuilder?.steps.push({
            Type: "Document Summary",
            Title: "Document Summary: " + parsedObj?.doc_id,
            ArtifactId: parsedObj?.doc_id,
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      if ((agentStep?.name ?? "").indexOf("analyze_dataset") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }

        if (
          retAibleBuilder?.steps?.find(
            (s) => Number(s?.DatasetId) === Number(parsedObj?.dataset_id) && s?.Original_Query === parsedObj?.query
          ) === undefined
        ) {
          retAibleBuilder?.steps.push({
            Type: "Analytics",
            Title: "Analytics: " + parsedObj?.dataset_id,
            DatasetId: parsedObj?.dataset_id,
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      if ((agentStep?.name ?? "").indexOf("whats_changed") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }

        if (
          retAibleBuilder?.steps?.find(
            (s) => Number(s?.DatasetId) === Number(parsedObj?.dataset_id) && s?.Original_Query === parsedObj?.query
          ) === undefined
        ) {
          retAibleBuilder?.steps.push({
            Type: "What's Changed",
            Title: "What's Changed: " + parsedObj?.dataset_id,
            DatasetId: parsedObj?.dataset_id,
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      if ((agentStep?.name ?? "").indexOf("deep_research") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }

        if (retAibleBuilder?.steps?.find((s) => s?.Original_Query === parsedObj?.query) === undefined) {
          retAibleBuilder?.steps.push({
            Type: "Deep Research",
            Title: "Deep Research: " + parsedObj?.query,
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      if ((agentStep?.name ?? "").indexOf("post_report_to_channel") !== -1) {
        const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
        let parsedObj;
        try {
          parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
        } catch (e) {
          console.log(e);
        }

        if (retAibleBuilder?.steps?.find((s) => s?.Original_Query === parsedObj?.query) === undefined) {
          retAibleBuilder?.steps.push({
            Type: "Publish Report to Slack",
            Title: "Publish Report to Slack",
            Prompt: "{{prompt}}",
            Original_Query: parsedObj?.query
          });
        }
      }

      /*
			if((agentStep?.name ?? "").indexOf("Function Start: perform_left_join") !== -1) {
				const jsonMatch = (agentStep?.input ?? "")?.match(/```json\s*([\s\S]*?)\s*```/);
				let parsedObj;
				try {
					parsedObj = JSON.parse(jsonMatch?.[1].trim().replace(/'/g, '"'));
				}
				catch(e) {
					console.log(e);
				}

				retAibleBuilder?.steps.push({
					Type: "Dataset Join",
					Title: "Dataset Join: " + parsedObj?.dataset_id_1 + " and " + parsedObj?.dataset_id_2,
					Dataset_Id_1: parsedObj?.dataset_id_1,
					Dataset_Id_2: parsedObj?.dataset_id_2,
					Left_Key: parsedObj?.left_key,
					Right_Key: parsedObj?.right_key,
					New_Dataset_Name: parsedObj?.new_dataset_name,
				});
			}
			*/
    });

    if (retAibleBuilder?.steps?.length >= 2) {
      retAibleBuilder.steps.push({
        Type: "Just Chat",
        Title: "Summary",
        Prompt:
          "Please Summarize the following output from some tool calls answering the user prompt:{{prompt}}, thanks!\n\n" +
          retAibleBuilder.steps.reduce((a, b, i) => a + (b?.Type + ":\n{{step_" + (i + 1) + ".ouput}}\n\n"), "")
      });
    }

    const NEW_AGENT_ID = "generated_workflow";
    dispatch(updateAibleAnywhere(NEW_AGENT_ID, retAibleBuilder));

    console.log("what is retAibleBuilder?", retAibleBuilder);

    dispatch(globalReducer.updateIsCreatingStepByStepAgent(false));

    if (window) {
      const savedAgent = await dispatch(saveAibleAnywhere(retAibleBuilder, retAibleBuilder?.name, false));

      return window.open("/agent/" + savedAgent?.id);
    }

    return dispatch(push("/agent/" + NEW_AGENT_ID + "/new"));
  };
}

export function generateWorkflowFromOpenShell(executionId, redirectOnSave = false, options) {
  return async (dispatch, getState) => {
    console.log("generateWorkflow executionId", executionId);

    dispatch(globalReducer.updateIsCreatingStepByStepAgent(true));

    let executionWorkflow = contentGenerationReducer.getExecutionWorkflowById(getState(), executionId);

    if (!executionWorkflow) {
      try {
        executionWorkflow = await dispatch(contentGenerationReducer.fetchExecutionWorkflowPlan(executionId));
      } catch (e) {
        console.log("Error fetching executionMetadata: ", e);
        dispatch(globalReducer.updateIsCreatingStepByStepAgent(false));
        toast("There was an error saving your plan, please try again.", {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 7500
        });
        return Promise.resolve();
      }
    }

    let retAibleBuilder = {
      name: options?.name ?? "New Aible Workflow",
      description: options?.description?.length ? options?.description : "Auto generated Workflow from OpenShell",
      isAibleAgent: true,
      execution_steps: executionWorkflow?.data?.steps,
      executionId: executionId,
      runToggle: "BACKEND",
      tags: options?.tags ?? ["AIBLE_SAFE_CLAW"],
      workflowOrigin: "OPENSHELL"
    };

    const NEW_AGENT_ID = "openshell_generated_workflow";
    dispatch(updateAibleAnywhere(NEW_AGENT_ID, retAibleBuilder));

    console.log("what is retAibleBuilder?", retAibleBuilder);

    const savedAgent = await dispatch(
      saveAibleAnywhere(
        retAibleBuilder,
        retAibleBuilder?.name,
        false,
        undefined,
        undefined,
        options?.saveToMyWork !== undefined ? options.saveToMyWork : true,
        true
      )
    );

    dispatch(globalReducer.updateIsCreatingStepByStepAgent(false));

    if (redirectOnSave) {
      dispatch(viewReducer.updateAgentAutonomyView("LOW"));
      dispatch(viewReducer.handleAgentAutonomyView("LOW"));
      dispatch(push("/agent/" + savedAgent?.id + "/template"));
    }
    return savedAgent;
  };
}

export function saveGeneratedWorkflow(agent, redirectOnSave = false, options) {
  return async (dispatch, getState) => {
    console.log("Saving generated workflow executionId", agent, agent?.executionId);

    if (!agent || !agent?.executionId) {
      return Promise.resolve();
    }

    let retAibleBuilder = {
      name: options?.name ?? "New Aible Workflow",
      description: options?.description?.length ? options?.description : "Auto generated Workflow from OpenShell",
      isAibleAgent: true,
      execution_steps: agent?.execution_steps,
      executionId: agent?.executionId,
      originalPrompt: options?.originalPrompt ?? agent?.originalPrompt,
      runToggle: "BACKEND",
      tags: options?.tags ?? ["AIBLE_SAFE_CLAW"],
      workflowOrigin: "OPENSHELL",
      introMessage: options?.introMessage,
      inputPlaceholder: options?.inputPlaceholder
    };

    dispatch(updateAibleAnywhere(agent?.id ?? `openshell_generated_workflow_${agent?.executionId}`, retAibleBuilder));

    console.log("what is retAibleBuilder?", retAibleBuilder);

    const savedAgent = await dispatch(
      saveAibleAnywhere(
        retAibleBuilder,
        retAibleBuilder?.name,
        false,
        undefined,
        true,
        options?.saveToMyWork !== undefined ? options.saveToMyWork : true,
        true,
        false
      )
    );

    dispatch(globalReducer.updateIsCreatingStepByStepAgent(false));

    if (redirectOnSave) {
      dispatch(viewReducer.updateAgentAutonomyView("LOW"));
      dispatch(viewReducer.handleAgentAutonomyView("LOW"));
      dispatch(push("/agent/" + savedAgent?.id + (options.isTemplate ? "/template" : "/new")));
    }
    return savedAgent;
  };
}

function createAAFromBlueprint(bp) {
  let original_tool_list = undefined;

  try {
    original_tool_list = JSON.parse(JSON.stringify(bp?.wizard?.aibleAnywhere?.tool_list));
  } catch (e) {}

  return {
    ...bp.wizard.aibleAnywhere,
    id: bp.id,
    created_date: bp?.created_date,
    updated_date: bp?.updated_date,
    original_tool_list: original_tool_list,
    isAibleBuilder: true
  };
}

export function fetchAAProject(id) {
  return (dispatch, getState) => {
    const blueprint = blueprintReducer.getBlueprint(getState(), id);
    if (blueprint?.wizard?.aibleAnywhere) {
      const aaEntry = createAAFromBlueprint(blueprint);
      dispatch(updateAibleAnywhere(id, aaEntry));
    }
  };
}

export function fetchAA(isClear = false) {
  return (dispatch, getState) => {
    let aaBase = { ...(isClear === true ? initialState : getBase(getState())) };
    const blueprints = blueprintReducer.getBlueprints(getState());

    const folderId = foldersReducer.getSelectedFolder(getState());

    blueprints
      .filter((bp) => bp?.folder_id === folderId)
      .filter((bp) => bp?.wizard?.aibleAnywhere !== undefined)
      .forEach((bp) => {
        aaBase[bp.id] = createAAFromBlueprint(bp);
      });

    dispatch(updateBase(aaBase));

    console.log("what is aaBase blueprints", aaBase, blueprints);
  };
}

export function initSafeClawOptimize(nextId) {
  return (dispatch, getState) => {
    const nextPredictObj = reportReducer.getReport(getState(), nextId);

    if (nextPredictObj?.metadata?.chatGPTConvo?.optimizeSetup === undefined) {
      dispatch(chatGPTReducer.updateChatType("OPTIMIZE"));
      dispatch(
        chatGPTReducer.updateOptimizeSetup({
          datasetId: nextPredictObj?.metadata?.explorations?.[0]?.datasetId,
          nextId: nextId,
          projectId: nextPredictObj?.metadata?.explorations?.[0]?.projectId
        })
      );
    }

    dispatch(updatePredictNextId(nextId));
  };
}

export default aibleAnywhereReducer;
